export enum EnumDataTracking {
  ClickImageCard = 'click_image_card',
  ClickBanner = 'click_banner',
  OpenAPP = 'open_app',
  ClickFeedback = 'click_feedback',
}
